import { useState } from "react";
import { useAppDispatch } from "../store/hooks";
import { confirmForgotPassword, forgotPassword } from "../api/thunks/users";
import { useNavigate } from "react-router-dom";
import { setNotification } from "../store/notifications-reducer";

export const ForgotPasswordComponent = () => {
    document.title = "Forgot Password | PocketQuant";
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [showConfirmCodeForm, setShowConfirmCodeForm] = useState(false);

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const email = (e.currentTarget.elements[0] as HTMLInputElement).value;
        console.log(email);
        const res = await dispatch(forgotPassword(email));
        if (res.meta.requestStatus !== 'fulfilled') {
            dispatch(setNotification({
                message: 'Failed to send forgot password email',
                type: 'error'
            }))
            return;
        }

        dispatch(setNotification({
            message: 'Password reset email sent',
            type: 'success'
        }));
        setShowConfirmCodeForm(true);
    }

    const handleSubmitConfirmCode = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const email = (e.currentTarget.elements[0] as HTMLInputElement).value;
        const code = (e.currentTarget.elements[1] as HTMLInputElement).value;
        const password = (e.currentTarget.elements[2] as HTMLInputElement).value;
        console.log(email, code, password);

        const res = await dispatch(confirmForgotPassword({ email, code, password }));

        if (res.meta.requestStatus !== 'fulfilled') {
            alert('Failed to reset password');
            return;
        }

        alert('Password reset successful');
        navigate('/login');
    }

    return (
        <>
            {
                showConfirmCodeForm && (
                    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                            <a href="/">
                                <img
                                    className="mx-auto rounded-lg h-20 w-auto"
                                    src="pq-icon-512.png"
                                    alt="PocketQuant Logo"
                                />
                            </a>
                            <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                                Reset your password
                            </h2>
                        </div>

                        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                            <form className="space-y-6" onSubmit={handleSubmitConfirmCode}>
                                <div>
                                    <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                        Email address
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            autoComplete="email"
                                            required
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label htmlFor="code" className="block text-sm font-medium leading-6 text-gray-900">
                                        Code
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="code"
                                            name="code"
                                            type="text"
                                            autoComplete="code"
                                            required
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <div className="flex items-center justify-between">
                                        <label htmlFor="password" className="block text-sm font-medium leading-6 text-gray-900">
                                            New Password
                                        </label>
                                    </div>
                                    <div className="mt-2">
                                        <input
                                            id="password"
                                            name="password"
                                            type="password"
                                            autoComplete="current-password"
                                            required
                                            className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                        />
                                    </div>
                                </div>

                                <div>
                                    <button
                                        type="submit"
                                        className="flex w-full justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                                    >
                                        Reset Password
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )
            }
            {!showConfirmCodeForm && (
                <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
                    <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                        <a href="/">
                            <img
                                className="mx-auto h-20 rounded-lg w-auto"
                                src="pq-icon-512.png"
                                alt="PocketQuant Logo"
                            />
                        </a>
                        <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900">
                            Reset your password
                        </h2>
                    </div>

                    <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
                        <form className="space-y-6" onSubmit={handleSubmit}>
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium leading-6 text-gray-900">
                                    Email address
                                </label>
                                <div className="mt-2">
                                    <input
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        required
                                        className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-orange-600 sm:text-sm sm:leading-6"
                                    />
                                </div>
                            </div>

                            <div>
                                <button
                                    type="submit"
                                    className="flex w-full justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                                >
                                    Forgot Password
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </>
    )
}